/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3BitcoinNumberOfUtxosFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3BitcoinNumberOfUtxosFormat = ClosedEnum<
  typeof GetApiV3BitcoinNumberOfUtxosFormat
>;

/**
 * Network
 */
export const GetApiV3BitcoinNumberOfUtxosNetwork = {
  Mainnet: "mainnet",
  Testnet: "testnet",
} as const;
/**
 * Network
 */
export type GetApiV3BitcoinNumberOfUtxosNetwork = ClosedEnum<
  typeof GetApiV3BitcoinNumberOfUtxosNetwork
>;

export type GetApiV3BitcoinNumberOfUtxosRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3BitcoinNumberOfUtxosFormat | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
  /**
   * Network
   */
  network?: GetApiV3BitcoinNumberOfUtxosNetwork | undefined;
};

/** @internal */
export const GetApiV3BitcoinNumberOfUtxosFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3BitcoinNumberOfUtxosFormat
> = z.nativeEnum(GetApiV3BitcoinNumberOfUtxosFormat);

/** @internal */
export const GetApiV3BitcoinNumberOfUtxosFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3BitcoinNumberOfUtxosFormat
> = GetApiV3BitcoinNumberOfUtxosFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3BitcoinNumberOfUtxosFormat$ {
  /** @deprecated use `GetApiV3BitcoinNumberOfUtxosFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3BitcoinNumberOfUtxosFormat$inboundSchema;
  /** @deprecated use `GetApiV3BitcoinNumberOfUtxosFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3BitcoinNumberOfUtxosFormat$outboundSchema;
}

/** @internal */
export const GetApiV3BitcoinNumberOfUtxosNetwork$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3BitcoinNumberOfUtxosNetwork
> = z.nativeEnum(GetApiV3BitcoinNumberOfUtxosNetwork);

/** @internal */
export const GetApiV3BitcoinNumberOfUtxosNetwork$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3BitcoinNumberOfUtxosNetwork> =
    GetApiV3BitcoinNumberOfUtxosNetwork$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3BitcoinNumberOfUtxosNetwork$ {
  /** @deprecated use `GetApiV3BitcoinNumberOfUtxosNetwork$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3BitcoinNumberOfUtxosNetwork$inboundSchema;
  /** @deprecated use `GetApiV3BitcoinNumberOfUtxosNetwork$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3BitcoinNumberOfUtxosNetwork$outboundSchema;
}

/** @internal */
export const GetApiV3BitcoinNumberOfUtxosRequest$inboundSchema: z.ZodType<
  GetApiV3BitcoinNumberOfUtxosRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start: z.nullable(z.number()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3BitcoinNumberOfUtxosFormat$inboundSchema.default("json"),
  step: z.number().default(7200),
  network: GetApiV3BitcoinNumberOfUtxosNetwork$inboundSchema.default("mainnet"),
});

/** @internal */
export type GetApiV3BitcoinNumberOfUtxosRequest$Outbound = {
  start: number | null;
  end: number | null;
  format: string;
  step: number;
  network: string;
};

/** @internal */
export const GetApiV3BitcoinNumberOfUtxosRequest$outboundSchema: z.ZodType<
  GetApiV3BitcoinNumberOfUtxosRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3BitcoinNumberOfUtxosRequest
> = z.object({
  start: z.nullable(z.number()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3BitcoinNumberOfUtxosFormat$outboundSchema.default("json"),
  step: z.number().default(7200),
  network: GetApiV3BitcoinNumberOfUtxosNetwork$outboundSchema.default(
    "mainnet",
  ),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3BitcoinNumberOfUtxosRequest$ {
  /** @deprecated use `GetApiV3BitcoinNumberOfUtxosRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3BitcoinNumberOfUtxosRequest$inboundSchema;
  /** @deprecated use `GetApiV3BitcoinNumberOfUtxosRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3BitcoinNumberOfUtxosRequest$outboundSchema;
  /** @deprecated use `GetApiV3BitcoinNumberOfUtxosRequest$Outbound` instead. */
  export type Outbound = GetApiV3BitcoinNumberOfUtxosRequest$Outbound;
}

export function getApiV3BitcoinNumberOfUtxosRequestToJSON(
  getApiV3BitcoinNumberOfUtxosRequest: GetApiV3BitcoinNumberOfUtxosRequest,
): string {
  return JSON.stringify(
    GetApiV3BitcoinNumberOfUtxosRequest$outboundSchema.parse(
      getApiV3BitcoinNumberOfUtxosRequest,
    ),
  );
}

export function getApiV3BitcoinNumberOfUtxosRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3BitcoinNumberOfUtxosRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3BitcoinNumberOfUtxosRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3BitcoinNumberOfUtxosRequest' from JSON`,
  );
}
